import React, { useState } from 'react';
import NotificationCenter from './NotificationCenter';
import UserAccountMenu from './UserAccountMenu';
import GlobalSearch from './GlobalSearch';
import { useAuth } from './AuthContext';

const Header = ({ activeMenu, user, onToggleSidebar, onOpenHelpCenter, onNavigateToModule }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showUserAccountMenu, setShowUserAccountMenu] = useState(false);
  const { logout } = useAuth();
  
  console.log('Header rendered with user:', user);
  console.log('showUserAccountMenu current state:', showUserAccountMenu);
  
  const handleUserMenuClick = () => {
    console.log('User menu button clicked - BEFORE state change:', showUserAccountMenu);
    setShowUserAccountMenu(true);
    console.log('User menu button clicked - AFTER state change attempt');
  };

  const getPageTitle = () => {
    switch (activeMenu) {
      case 'dashboard':
        return 'Tableau de bord';
      case 'create':
        return 'Créer un document';
      case 'documents':
        return 'Documents';
      case 'clients':
        return 'Clients CRM';
      case 'opportunities':
        return 'Opportunités';
      case 'operations':
        return 'Opérations';
      case 'contacts':
        return 'Contacts';
      case 'export':
        return 'Export & Rapports';
      case 'settings':
        return 'Paramètres';
      case 'users':
        return 'Gestion des utilisateurs';
      default:
        return 'Baobab Connect';
    }
  };

  const getPageDescription = () => {
    switch (activeMenu) {
      case 'dashboard':
        return 'Vue d\'ensemble de votre activité commerciale';
      case 'opportunities':
        return 'Gérez vos opportunités commerciales';
      case 'operations':
        return 'Suivi de vos opérations logistiques';
      case 'documents':
        return 'Gestion centralisée de vos documents';
      case 'clients':
        return 'Base de données clients et prospects';
      case 'contacts':
        return 'Répertoire de vos contacts professionnels';
      case 'export':
        return 'Rapports et analyses détaillées';
      case 'settings':
        return 'Configuration de l\'application';
      case 'users':
        return 'Administration des utilisateurs';
      default:
        return 'Plateforme de gestion commerciale et logistique';
    }
  };

  return (
    <header className="baobab-header">
      <div className="baobab-header-content">
        <div className="baobab-header-main">
          {/* Mobile menu button */}
          <button
            onClick={onToggleSidebar}
            className="lg:hidden p-1.5 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-baobab-primary"
            aria-label="Toggle sidebar"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          {/* Titre compact */}
          <div className="baobab-title-section">
            <h1 className="baobab-title">{getPageTitle()}</h1>
          </div>
          
          {/* Actions du header */}
          <div className="baobab-actions">
            {/* Recherche globale - masquée sur mobile et tablette */}
            <div className="hidden lg:block">
              <GlobalSearch onNavigate={onNavigateToModule} />
              <div className="baobab-tooltip-content">
                Recherche globale
              </div>
            </div>
            
            {/* Notification Center */}
            <NotificationCenter currentUser={user} />
            
            {/* Bouton Centre d'aide */}
            <div className="baobab-tooltip relative">
              <button
                onClick={onOpenHelpCenter}
                className="baobab-glass-button p-1.5 hover:shadow-md transition-all duration-200"
                title="Centre d'aide"
              >
                <svg className="w-4.5 h-4.5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
              <div className="baobab-tooltip-content">
                Centre d'aide
              </div>
            </div>
            
            {/* Menu utilisateur compact */}
            <div className="user-account-menu">
              <button
                onClick={handleUserMenuClick}
                data-testid="user-menu-button"
                className="baobab-glass-button flex items-center gap-2 p-1.5 hover:shadow-md transition-all duration-200"
              >
                <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center ring-2 ring-white">
                  <span className="text-white font-semibold text-xs">
                    {user?.full_name?.charAt(0).toUpperCase() || 'U'}
                  </span>
                </div>
                <div className="hidden xl:block text-left">
                  <div className="text-xs font-medium text-gray-900">
                    {user?.full_name || 'Utilisateur'}
                  </div>
                </div>
                <svg className="w-3.5 h-3.5 text-gray-400 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Menu déroulant utilisateur */}
              {showUserAccountMenu && user && (
                <UserAccountMenu 
                  user={user} 
                  onClose={() => {
                    console.log('Closing user account menu');
                    setShowUserAccountMenu(false);
                  }} 
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;